import { w } from 'windstitch';

export const Wrapper = w.div(
  'w-full px-4 lg:px-8 relative',
);

export const ContentBox = w.div(
  ' flex md:flex items-center text-left w-full bg-[var(--rosa)] rounded-xl text-white p-8 md:p-12 lg:justify-between xl:ContentBox max-h-[750px]',
);

export const Title = w.h1(
  'text-4xl md:text-5xl xl:text-7xl'
)

export const Text = w.ul(
  'text-xl lg:text-2xl mt-10 md:mt-12  list-disc list-inside'
)

export const Image = w.img(
  'w-full h-[451px] w-[400px] md:h-[526px] md:min-h-[526px] md:w-[475px] md:min-w-[475px]  mt-10 md:mt-0 sm:-mr-[160px] md:-mr-[145px] lg:-mr-18  2xl:-mr-12 lg:w-[575px] lg:min-w-[575px] lg:h-[626px] lg:min-h-[626px] 2xl:w-[775px] 2xl:min-w-[775px] 2xl:h-[826px] 2xl:min-h-[826px] hidden sm:block'
)

export const Btn = w.button(
  'relative bg-white rounded-full text-[var(--azul)] font-bold px-12 py-3 mt-16'
)
